import React from "react";

/** The design floor's body grid: `1.55fr / 0.85fr` from ~960px, one column below it. This
 * REPLACES `BusinessMiniSite`'s old `lg:grid-cols-[1.4fr_0.6fr]` two-column tab layout — the one
 * intentional visible change in this PR (tabs -> a scrolling stacked body). `main`/`aside` are
 * plain slots; the caller decides what goes in each. */
export function BodyGrid({ main, aside }) {
  return (
    <div className="mx-auto grid w-full max-w-7xl gap-10 px-5 py-10 sm:px-8 min-[960px]:grid-cols-[1.55fr_0.85fr]">
      <div className="space-y-10">{main}</div>
      <aside className="space-y-4">{aside}</aside>
    </div>
  );
}
